export default __webpack_public_path__ + "static/media/fondo_trivia.9d7b719f.png";